export const VIDEO_MODAL = {
  open: "VIDEO_MODAL_OPEN",
  close: "VIDEO_MODAL_CLOSE",
};
